module.exports = __webpack_public_path__ + "static/media/export-icon.7b7c8d7c.svg";